import React from "react";
import { Mic, Music, Play, Youtube, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheAudioExperience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const platforms = [{
    name: "Apple Podcasts",
    icon: <Mic className="w-5 h-5" />,
    url: "https://podcasts.apple.com"
  }, {
    name: "Spotify",
    icon: <Music className="w-5 h-5" />,
    url: "https://spotify.com"
  }, {
    name: "Google Podcasts",
    icon: <Play className="w-5 h-5" />,
    url: "https://podcasts.google.com"
  }, {
    name: "YouTube",
    icon: <Youtube className="w-5 h-5" />,
    url: "https://youtube.com"
  }];
  return;
}